import { useMultipleChartsExport } from '@ecosystem/export-utils';
import { InsightExporter } from '@ecosystem/newron-client-collections';
import { useEffect } from 'react';
import { exportPowerPointImages } from '../ExportUtils';

interface UseRegisterExportParams {
  numberOfChartsToExport: number;
  onExportReady: (exporter: InsightExporter) => void;
  chartRef: boolean[];
  onExportAfter?: () => void;
}

export const useRegisterExport = ({
  numberOfChartsToExport,
  onExportReady,
  chartRef,
  onExportAfter,
}: UseRegisterExportParams) => {
  const multipleChartsExport = useMultipleChartsExport(numberOfChartsToExport);

  useEffect(() => {
    if (chartRef.every((ref) => ref) && chartRef.length !== 0) {
      const exportPng = exportPowerPointImages(multipleChartsExport, onExportAfter);
      onExportReady({ exportPng });
    }
  }, [onExportReady, chartRef]);

  return { multipleChartsExport };
};
